module.exports = "/images/samsung.jpg";